import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
let Modal = class Modal extends Vue {
};
Modal = __decorate([
    Component({
        data() {
            return {
                showmodal: false,
            };
        },
    })
], Modal);
export default Modal;
